/*
<summary>
   This function builds the query string fragment shared by GetCrimpToolInspectionList,
   GetUserInspectedList and their CSV export endpoints, from the ISharedInspectionFilter
   fields the Equipment Inspection Menu's filter bar submits.
   Developer: Aashish Singh, Created Date: 01-Sep-2026
</summary>
*/

import { ISharedInspectionFilter } from '../../../models/ISharedInspectionFilter';

export const buildInspectionFilterQuery = (filter?: ISharedInspectionFilter): string => {
  if (!filter) return '';
  const params = new URLSearchParams();
  if (filter.OwnerFactoryId && filter.OwnerFactoryId !== -1) {
    params.set('OwnerFactoryId', String(filter.OwnerFactoryId));
  }
  if (filter.ToolManagementNo) params.set('ToolManagementNo', filter.ToolManagementNo);
  if (filter.ToolName) params.set('ToolName', filter.ToolName);
  if (filter.InspectionDateFrom) params.set('InspectionDateFrom', filter.InspectionDateFrom);
  if (filter.InspectionDateTo) params.set('InspectionDateTo', filter.InspectionDateTo);
  if (filter.JudgmentResult === 'OK') params.set('JudgmentResult', '1');
  if (filter.JudgmentResult === 'NG') params.set('JudgmentResult', '0');
  const query = params.toString();
  return query ? `&${query}` : '';
};
